import { fetchCommunityFeedPage } from '../services/PostService';
import { captureQueryScope } from './queryOwnership';
import { credentialCacheScope } from '../services/credentialCacheScope';

// Share the first page between navigation intent and the destination. Keep it
// short lived and isolated by account, community and the current credential.
export const newsFirstPageQuery = ({ userId, communityId, token, scope = captureQueryScope({ user: { id: userId }, token, communityId }) }) => ({
  queryKey: ['news', 'first-page', userId, communityId, scope?.sessionId && !scope.sessionId.startsWith('standalone-') ? scope.sessionId : credentialCacheScope(token)],
  staleTime: 30_000,
  gcTime: 60_000,
  retry: false,
  queryFn: ({ signal }) => fetchCommunityFeedPage(communityId, { token, signal }),
});
